<template>
    <!-- 投影点位图上传 -->
    <div class="upLoadBox" :class="editLook == 2 ? 'disabledAdd' : ''">
        <header>{{title}}</header>
        <!-- <div v-if="editLook == 2 && formValue">
            <template v-if="name == 'photoLandingEffect'">
                <img  class="lookImg" @click.stop="handlePictureCardPreview({url:'' + item})" v-for="item in formValue" :src="item" :key="item" alt="">
            </template>
            <tempalte v-else>
                <img  class="lookImg" @click.stop="handlePictureCardPreview({url:ImgPath + item})" v-for="item in formValue.split(',')" :src="ImgPath + item" :key="item" alt="">
            </tempalte>
        </div> -->
        <el-upload
            :action="uploadUrl"
            :headers="headers"
            list-type="picture-card"
            :on-success="uploadSuccess"
            :on-exceed="exceedFn"
            :file-list="fileList"
            multiple
            :limit="9">
                <i slot="default" class="el-icon-plus" ></i>
                <div slot="file" slot-scope="{file}" :ref="file.uid">
                    <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                        <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                        >
                        <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                        v-if="editLook != 2"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                        >
                        <i class="el-icon-delete"></i>
                        </span>
                    </span>
                </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            default:''
        },
        // 上传文件名字段
        name:{
            default:''
        },
        formValue:{
            default:''
        },
        editLook:{
            default:0
        }
    },
  data() {
    return {
        dialogImageUrl: '',
        dialogVisible: false,
        uploadUrl:'',
        imgUrlArr:[],
        headers: {
            "Authorization": localStorage.getItem('token')
        },
        fileList:[]
    }
  },
  created(){
    this.uploadUrl = this.$http.getSignUrl('/api/files/upload', {
        type: 'image'
    })
    if(this.formValue.length > 0 && this.name != 'photoLandingEffect'){
        for(var i=0;i<this.formValue.split(',').length;i++){
            this.fileList.push({
                url:this.ImgPath + this.formValue.split(',')[i]
            })
            this.imgUrlArr.push(this.formValue.split(',')[i])
        }
        this.$emit('changeImgData',this.name,this.imgUrlArr)
    }else if(this.formValue.length > 0 && this.name == 'photoLandingEffect'){
        
         for(var i=0;i<this.formValue.length;i++){
            this.fileList.push({
                url:this.formValue[i]
            })
            this.imgUrlArr.push(this.formValue[i])
        }
        this.$emit('changeImgData',this.name,this.imgUrlArr)
        
    }else{
        this.fileList = [];
    }
  },
  mounted(){
  },
  methods: { 
     handleRemove(file) {
        this.imgUrlArr = this.imgUrlArr.filter((e)=>{
            return e.originalFileName != file.name
        })
        this.$refs[file.uid].parentNode.remove();
        //修改父元素数据
        this.$emit('changeImgData',this.name,this.imgUrlArr)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;

      },
    // 上传成功
    uploadSuccess(res){
        if(res.success){
            this.imgUrlArr.push(res.data.savePath)
        }
        //修改父元素数据
        this.$emit('changeImgData',this.name,this.imgUrlArr)
    },
    // 文件超出最多个数
    exceedFn(){
        this.$alert('超过最大上传数量', {
          confirmButtonText: '确定',
        });
    }
  },
};
</script>
<style lang="scss">
.lookImg{
    width: 50px;
    float: left;
    margin: 2px 6px;
}
.disabledAdd{
    .el-upload--picture-card{
        display: none;
    }
}
</style>